import React from "react";
import * as User from "./store/User";
import * as SnackbarStore from "./store/SnackbarStore";
import { connect } from "react-redux";
import AdminWrapper from "./wrappers/admin/Admin.Wrapper";
import { bindActionCreators } from "redux";
import axios from "axios";

class App extends React.Component {
  constructor(props) {
    super(props);
    const { requestUser } = props;
    this.configureInterceptor();
    requestUser();
  }

  configureInterceptor() {
    const { sendError } = this.props;
    // Add a response interceptor
    axios.interceptors.response.use(
      function(response) {
        return response;
      },
      function(error) {
        if (error && error.response) {
          if (error.response.status >= 500) {
            sendError(error.response.data);
          } else if (error.response.status === 401) {
            window.location = "/unauthorized";
          } else if (error.response.status >= 400) {
            sendError(error.response.data);
          }
        }
        return Promise.reject(error);
      }
    );
  }

  render() {
    return <AdminWrapper />;
  }
}

export default connect(
  state => state,
  dispatch =>
    bindActionCreators(
      Object.assign({}, User.actionCreators, SnackbarStore.actionCreators),
      dispatch
    )
)(App);
